import "datatables.net-dt/js/dataTables.dataTables.js";
import { Icon } from "@iconify/react/dist/iconify.js";
import { toast } from 'react-toastify';
import { Modal, Popover, Tabs } from 'antd';
import { useNavigate } from "react-router-dom";
import { api } from "../../utils/apiClient";
import { useSelector } from "react-redux";
import { API } from "../../config/constants";
import Pagination from "../../utils/Pagination";
import { formatDateToDMY, formatTime12Hour, formatEventType } from "../../utils/tools";
import ContentLoader from "../../utils/ContentLoader";
import { useState } from "react";
import SearchBy from "../../utils/SearchBy";
import { TableSortHeaders } from "../../utils/TableSortHeaders";
import ImagePreviewModal from "../../utils/ImagePreviewModal";

const { confirm } = Modal;

const ChurchesTable = ({
      readingplan,
      roles,
      page,
      setPage,
      totalPages,
      totalEntries,
      sort,
      order,
      setOrder,
      setSort,
      search,
      setSearch,
      fetchReadingPlan,
      onView,
      entriesPerPage,
      setEntriesPerPage
}) => {
      const viewPermissions = useSelector((state) => state.permission.rolePermissions) || [];
      const [loading, setLoading] = useState(false);
      const navigate = useNavigate();

      // console.log("churches table ====>", readingplan);

      const headerConfig = [
            { key: "church_name", label: "Church Name", sortable: false },
            { key: "place", label: "Place", sortable: false },
            { key: "latitude", label: "Latitude", sortable: false },
            { key: "longitude", label: "Longitude", sortable: false },
            { key: "link", label: "Link", sortable: false },
            { key: "action", label: "Action", sortable: false }
      ];

      if (loading) return <ContentLoader />;

      return (
            <div className="card basic-data-table text-sm overflow-x-auto">
                  <div className="card-header responsive-header d-flex justify-content-end align-items-center global-header">
                        <div className="d-flex align-items-center gap-3">
                              {/* Refresh Icon */}
                              <Icon
                                    icon="mdi:refresh"
                                    width="26"
                                    height="26"
                                    className="ms-2 text-lg d-none d-md-inline-flex refresh-icon "
                                    onClick={fetchReadingPlan}
                              />

                              <div className="search-container" style={{ gap: "10px" }}>
                                    <SearchBy
                                          value={search}
                                          onChange={(e) => {
                                                setSearch(e.target.value);
                                                setPage(1);
                                          }}
                                    />
                                    {viewPermissions.includes("readingplan.create") && (
                                          <button
                                                className="btn btn-primary-600 global-add-btn"
                                                type="button"
                                                onClick={() => navigate("/events-form")}
                                          >
                                                <Icon
                                                      icon="fa6-regular:square-plus"
                                                      className="icon text-lg line-height-1"
                                                />
                                                Add
                                          </button>
                                    )}
                              </div>
                        </div>
                  </div>
                  <div className="card-body card-body-modify">
                        <div className="w-full overflow-x-auto">
                              <table className="table bordered-table mb-0 text-sm w-full min-w-max" id="dataTable">
                                    <thead>
                                          <tr>
                                                {TableSortHeaders(headerConfig, sort, order, setSort, setOrder, setPage)}
                                          </tr>
                                    </thead>
                                    <tbody>
                                          {Array.isArray(readingplan) && readingplan.length > 0 ? (
                                                readingplan.map((item) => (
                                                      <tr key={item.id}>
                                                            {/* Event Title */}
                                                            {/* <td>{item.id}</td> */}

                                                            {/* Church Name */}
                                                            <td className="d-flex align-items-center gap-2">
                                                                  <span>{item.name}</span>
                                                            </td>



                                                            {/* Start Date & Time */}
                                                            <td>
                                                                  {item.place}
                                                            </td>

                                                            {/*Plan Type */}
                                                            <td>
                                                                  {item.latitude}
                                                            </td>


                                                            {/*Plan Type */}
                                                            <td>
                                                                  {item.longitude}
                                                            </td>

                                                            <td>
                                                                  {item.link ? (
                                                                        <a
                                                                              href={item.link}
                                                                              target="_blank"
                                                                              rel="noopener noreferrer"
                                                                              style={{ color: "#1677ff", fontWeight: 500 }}
                                                                        >
                                                                              Open Link
                                                                        </a>
                                                                  ) : (
                                                                        "-"
                                                                  )}
                                                            </td>

                                                            {/* Actions */}
                                                            <td>
                                                                  <div className="d-flex align-items-center justify-content-between">

                                                                        {/* Left Side - View Icon */}
                                                                        {viewPermissions.includes("event.view") && (
                                                                              <button
                                                                                    className="w-32-px h-32-px me-8 bg-primary-light text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center"
                                                                                    onClick={() => onView(item)}
                                                                              >
                                                                                    <Icon icon="iconamoon:eye-light" />
                                                                              </button>
                                                                        )}
                                                                  </div>
                                                            </td>
                                                      </tr>
                                                ))
                                          ) : (
                                                <tr>
                                                      <td colSpan={7} className="text-center">
                                                            No Event found
                                                      </td>
                                                </tr>
                                          )}
                                    </tbody>
                              </table>
                        </div>
                        <Pagination
                              page={page}
                              setPage={setPage}
                              totalPages={totalPages}
                              totalEntries={totalEntries}
                              entriesPerPage={entriesPerPage}
                              setEntriesPerPage={setEntriesPerPage}
                        />
                  </div>
            </div>
      );
};

export default ChurchesTable;